/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * What a single draw won: cash (in cents) and free plays. Produced by the wallet parser and keyed by
 * draw number on ParsedTicketGame.winningsByDrawNumber. An entry exists only for a draw that won something,
 * so a present entry may still have a zero in one field (e.g. a free-play-only win has winInCents 0).
 * @export
 * @interface DrawWinnings
 */
export interface DrawWinnings {
    /**
     * Count of additional (non-cash) winnings won on this draw (free plays today).
     * @type {number}
     * @memberof DrawWinnings
     */
    additionalWinnings: number;
    /**
     * Cash won on this draw, in cents.
     * @type {number}
     * @memberof DrawWinnings
     */
    winInCents: number;
}

/**
 * Check if a given object implements the DrawWinnings interface.
 */
export function instanceOfDrawWinnings(value: object): value is DrawWinnings {
    if (!('additionalWinnings' in value) || value['additionalWinnings'] === undefined) return false;
    if (!('winInCents' in value) || value['winInCents'] === undefined) return false;
    return true;
}

export function DrawWinningsFromJSON(json: any): DrawWinnings {
    return DrawWinningsFromJSONTyped(json, false);
}

export function DrawWinningsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawWinnings {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalWinnings': json['additionalWinnings'],
        'winInCents': json['winInCents'],
    };
}

export function DrawWinningsToJSON(value?: DrawWinnings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'additionalWinnings': value['additionalWinnings'],
        'winInCents': value['winInCents'],
    };
}

